/** Canonical profile URL for a creator price row (matches PlatformCard URLs). */

const getTikTokLink = (username: string) => {
  if (username[0] === "@") {
    return `https://www.tiktok.com/${username}`;
  }
  return `https://www.tiktok.com/@${username}`;
};

export function creatorPriceProfileUrl(platform: CreatorPrice): string {
  if (platform.platform === "instagram") {
    return `https://instagram.com/${platform.username}`;
  }
  if (platform.platform === "tiktok") {
    return getTikTokLink(platform.username);
  }
  if (platform.platform === "youtube") {
    return `https://youtube.com/@${platform.username}`;
  }
  if (platform.platform === "twitter") {
    return `https://twitter.com/${platform.username}`;
  }
  return "";
}
